import { render, staticRenderFns } from "./assignpermissions.vue?vue&type=template&id=669e2c0e&scoped=true"
import script from "./assignpermissions.vue?vue&type=script&lang=js"
export * from "./assignpermissions.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./assignpermissions.vue?vue&type=style&index=0&id=669e2c0e&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "669e2c0e",
  null
  ,true
)

export default component.exports